import { LOGUS_CONFIG } from '../config'
import axios from 'axios'

export default {

    /*
        GET     /api/groups
    */
    getGroups: function(options){
        return axios.get( LOGUS_CONFIG.API_URL + '/groups',{
            params:{
                offset:options.offset,
                itemsPerPage:options.itemsPerPage,
                orderBy:options.orderBy,
                orderDirection:options.orderDirection,
                showDeleted:options.showDeleted,
        }});
    },

    /*
        GET     /api/groups/search
    */
   searchGroups: function(options){
    return axios.get( LOGUS_CONFIG.API_URL + '/groups/search',{
        params:{
            showDeleted:options.showDeleted,
            filterableHeaders:options.filterableHeaders,
            q:options.q
    }});
},

    /*
		POST 	/api/groups
	*/
    postAddNewGroup: function( name, desktop, journal, report,settlement,payment, dictionary, setting, mobile ){
        return axios.post( LOGUS_CONFIG.API_URL + '/groups',
            {
                name: name,
                desktop: desktop,
                journal: journal,
                report: report,
                settlement:settlement,
                payment:payment,
                dictionary: dictionary,
                setting: setting,
                mobile: mobile,
            }
        );
    },

    /*
		GET 	/api/groups/{slug}/edit
	*/
    getGroupEdit: function( slug ){
		return axios.get( LOGUS_CONFIG.API_URL + '/groups/' + slug + '/edit' );
	},

    /*
		PUT 	/api/groups/{slug}
	*/
    putEditGroup: function(slug, name, desktop, journal, report,settlement,payment, dictionary, setting, mobile){
        return axios.put( LOGUS_CONFIG.API_URL + '/groups/'+ slug,
            {
                name: name,
                desktop: desktop,
                journal: journal,
                report: report,
                settlement:settlement,
                payment:payment,
                dictionary: dictionary,
                setting: setting,
                mobile: mobile,
            }
        );
    },

     /*
		GET 	/api/groups/reactivate/{slug}
	*/
    putReactivateGroup: function(slug){
        return axios.get( LOGUS_CONFIG.API_URL + '/groups/reactivate/' + slug);
    },

    /*
		DELETE /api/groups/{slug}
	*/
    deleteGroup: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/groups/' + slug );
    },
    
    /*
		DELETE /api/groups/{slug}/force
	*/
    forceDeleteGroup: function( slug ){
		return axios.delete( LOGUS_CONFIG.API_URL + '/groups/' + slug + '/force' );
	}
}